export default "__VITE_ASSET__n_F9xc6r__"